import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Check, Crown } from "lucide-react";
import { toast } from "sonner";

export default function SellerUpgrade() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const subscribe = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/checkout/subscription", { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch { toast.error("Could not start subscription"); setLoading(false); }
  };

  const features = [
    "Unlimited product listings",
    "Zero per-listing fees",
    "Auto-publish on upload",
    "Pro seller badge",
    "Cancel anytime",
  ];

  return (
    <div data-testid="seller-upgrade-page" className="pt-28 pb-24 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-xs uppercase tracking-[0.25em] text-zinc-500">Two ways to sell</p>
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-2 mb-12">Pick your plan.</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="card-surface p-8">
          <p className="badge-neon">Pay per listing</p>
          <p className="font-display font-black text-5xl mt-6">$0.50<span className="text-base text-zinc-500"> / product</span></p>
          <p className="text-sm text-zinc-400 mt-3">Best if you sell only a few items. Pay only when you publish.</p>
          <ul className="mt-8 space-y-3 text-sm">
            <li className="flex gap-2"><Check className="w-4 h-4 text-[#FF007F] mt-0.5" /> Publish one at a time</li>
            <li className="flex gap-2"><Check className="w-4 h-4 text-[#FF007F] mt-0.5" /> No commitment</li>
            <li className="flex gap-2"><Check className="w-4 h-4 text-[#FF007F] mt-0.5" /> Image hosting included</li>
          </ul>
          <Link to="/seller/new" data-testid="choose-payg" className="btn-secondary w-full inline-block text-center mt-10">Add a product</Link>
        </div>

        <div className="card-surface p-8 border-[#FF007F]/40 relative">
          <div className="absolute -top-3 left-8 bg-[#FF007F] text-white text-[10px] uppercase tracking-widest font-bold px-3 py-1 glow-pink">Most popular</div>
          <p className="badge-neon" style={{borderColor: "rgba(204,255,0,0.4)", color: "#CCFF00", background: "rgba(204,255,0,0.1)"}}>Pro Seller</p>
          <p className="font-display font-black text-5xl mt-6">$9.99<span className="text-base text-zinc-500"> / month</span></p>
          <p className="text-sm text-zinc-400 mt-3">Best for shops with multiple listings. Skip per-listing fees forever.</p>
          <ul className="mt-8 space-y-3 text-sm">
            {features.map(f => <li key={f} className="flex gap-2"><Check className="w-4 h-4 text-[#CCFF00] mt-0.5" /> {f}</li>)}
          </ul>
          {user?.seller_subscription_active ? (
            <button disabled className="btn-primary w-full mt-10" data-testid="pro-active-btn"><Crown className="w-4 h-4 inline mr-2" /> Pro Active</button>
          ) : (
            <button data-testid="subscribe-btn" onClick={subscribe} disabled={loading} className="btn-primary w-full mt-10">{loading ? "Redirecting…" : "Go Pro for $9.99/mo"}</button>
          )}
        </div>
      </div>
    </div>
  );
}
